import axios from './axios';

const createRentToOwnRequest = values => {
  return axios
    .post('/api/frontend/leads/search_assistance', {
      lead_search_assistance: {
        ad_id: values.adId,
        price_max: values.price,
        data: {
          rent_for_months: values.rentForMonths,
          rent_to_own_rent_price: values.rentToOwnRentPrice,
        },
        filter: {
          deal_type: 'rent_to_own',
        },
        receive_type: values.receiveType,
        receive_values: values.receiveValue,
      },
    })
    .then(({ data }) => data)
    .catch(({ response: { data: { errors } } }) => Promise.reject(errors));
};

export const rentToOwnForm = {
  createRentToOwnRequest,
};

export default rentToOwnForm;
